import { __awaiter, __generator } from "tslib";
import { fetchTuiNewUserState } from '@office-start/first-run-state-service';
import { TuiFlowInTestMode } from '@office-start/teaching-ui-config-service';
export var getNewUserState = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var newUserTuiEnabled, _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (config.teachingUiConfig.tuiFlowInTestMode ===
                    TuiFlowInTestMode.NewUserReact) {
                    return [2 /*return*/, {
                            CompletedFirstRun: false,
                            StepsCompleted: 0,
                            Version: config.teachingUiConfig.version,
                        }];
                }
                newUserTuiEnabled = (_c = (_b = config.featureGates.teachingUiGates) === null || _b === void 0 ? void 0 : _b.teachingUiNewUserEnabled) !== null && _c !== void 0 ? _c : false;
                if (!newUserTuiEnabled) return [3 /*break*/, 4];
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchTuiNewUserState()];
            case 2: return [2 /*return*/, _d.sent()];
            case 3:
                _a = _d.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, undefined];
        }
    });
}); };
//# sourceMappingURL=getNewUserState.js.map